/*
 * Developed by CQ Inversiones SAS.  Copyright (c) 2025. All rights reserved.
 * Desarrollado por CQ Inversiones SAS.  Copyright (c) 2025. Todos los derechos reservados.
 */

import { HttpErrorResponse } from '@angular/common/http';
import {Observable, UnaryFunction, pipe, tap, catchError, of} from 'rxjs';

/*
 * Project:      mkad-frontend
 * Developed by: Juan David Pelaez Cumbe
 * Date:         18/03/25
 * Module name:  signal-response
 * File name:    signal-response.ts
 * IDE:          WebStorm
 */


export function signalResponse<TResponse, TError = HttpErrorResponse>(
  onSuccess: (response: TResponse) => void,
  onError?: (error: TError) => void,
  onFinally?: () => void,
): UnaryFunction<Observable<TResponse>, Observable<TResponse | null>> {
  return pipe(
    tap({next: onSuccess, complete: onFinally}),
    catchError((error: unknown) => {
      onError?.(<TError>error);
      onFinally?.();
      return of(null);
    }),
  )
}
